import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => {
    const TABLET_OR_DESKTOP_BREAKPOINT = getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP);

    return {
        question: {
            color: theme.palette.secondary.main,
            fontWeight: theme.typography.fontWeightRegular,
        },
        radioGroup: {
            color: theme.palette.secondary.main,
        },
        radio: {
            color: theme.palette.secondary.main,
            "&.Mui-checked": {
                color: theme.palette.secondary.main,
            },
        },
        radioError: {
            color: theme.palette.error.main,
            "&.Mui-checked": {
                color: theme.palette.error.main,
            },
        },
        radioLabel: {
            color: theme.palette.secondary.main,
            "& .MuiFormControlLabel-label": {
                color: theme.palette.secondary.main,
            },
        },
        accordionContent: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(3, 4),
            "&:last-child": {
                paddingBottom: theme.spacing(5),
            },
        },
        warningText: {
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.primary.main,
        },
        instructionText: {
            color: theme.palette.secondary.main,
        },
        disclaimerText: {
            color: theme.palette.secondary.main,
            lineHeight: 1.4,
            [TABLET_OR_DESKTOP_BREAKPOINT]: {
                flexGrow: 1,
            },
        },
        disclaimerStack: {
            marginTop: theme.spacing(2.25),
        },
        agreeButton: {
            backgroundColor: theme.palette.primary.main,
            whiteSpace: "nowrap",
            width: "100%",
            [TABLET_OR_DESKTOP_BREAKPOINT]: {
                width: "auto",
            },
        },
        agreeButtonError: {
            border: `1px solid ${theme.palette.error.main}`,
        },
        buttonContainer: {
            display: "flex",
            width: "100%",
            [TABLET_OR_DESKTOP_BREAKPOINT]: {
                justifyContent: "flex-end",
                width: "auto",
            },
        },
        questionContainer: {
            padding: theme.spacing(0, 2, 2, 2),
            backgroundColor: theme.palette.background.dark,
            transition: theme.transitions.create("border-radius", {
                duration: theme.transitions.duration.standard,
                easing: theme.transitions.easing.easeInOut,
            }),
        },
        questionContainerCollapseOpen: {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
        },
    };
});
